import React, { useState } from 'react';
import { Facebook, Copy, Check, Share2, Smartphone } from 'lucide-react';
import { toast } from 'sonner';

const InstagramIcon = () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
    </svg>
);

const ViberIcon = () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
        <path d="M11.398.002C9.473.028 5.331.344 3.014 2.467 1.294 4.177.529 6.711.431 9.865c-.098 3.154-.229 9.07 5.546 10.691l.004.001.002.001v2.458s-.038.975.604 1.174c.777.242 1.233-.5 1.975-1.303.407-.44.966-1.087 1.389-1.581 3.826.322 6.769-.414 7.104-.525.773-.257 5.147-.812 5.863-6.632.74-6.002-.354-9.794-2.327-11.502C18.78.961 15.81.02 12.469.002h-1.071zM12.05 1.97c2.942-.012 5.58.773 7.028 2.034 1.677 1.444 2.622 4.813 1.972 10.1-.59 4.754-4.095 5.225-4.755 5.445-.272.092-2.837.729-6.1.506 0 0-2.417 2.917-3.173 3.681-.118.119-.259.168-.352.145-.131-.033-.167-.192-.166-.424l.02-4.017c-4.857-1.35-4.57-6.414-4.49-9.037.081-2.623.687-4.782 2.134-6.2 1.88-1.752 5.56-2.222 7.882-2.233zm.32 2.497a.425.425 0 00-.007.85c1.34.018 2.473.483 3.377 1.382.905.9 1.38 2.083 1.415 3.521a.425.425 0 10.85-.019c-.04-1.652-.6-3.029-1.666-4.09-1.064-1.06-2.39-1.622-3.942-1.644h-.028zm-3.184 1.266c-.214-.004-.42.065-.58.255l-.756.872c-.36.412-.405.95-.122 1.478.005.01.009.02.015.029 0 0 .022.042.063.12.041.079.101.194.177.342.153.297.37.728.62 1.254.516 1.082.651 1.584.437 1.993l-.021.04c-.225.427-.624.74-.887.975l-.29.262a.51.51 0 00-.073.088c-.16.248-.07.57.166 1.035 0 0 .907 1.705 2.122 2.952 1.07 1.098 2.476 1.834 2.825 2.002.553.267.884.316 1.104.053l.003-.004.001-.001.856-.937c.326-.358.736-.43 1.095-.245l2.545 1.298c.45.23.602.647.42 1.136a3.18 3.18 0 01-.762 1.1c-.454.423-.957.72-1.632.816-.983.14-2.233-.068-3.842-.86-1.577-.776-3.157-2.12-4.59-4.166-1.1-1.573-1.642-3.022-1.857-4.216-.215-1.194-.113-2.147.326-2.782.347-.503.877-.823 1.33-1.08a2.51 2.51 0 01.325-.16 1.09 1.09 0 01.38-.081zm3.594.778a.425.425 0 00-.02.85c.832.038 1.478.334 1.96.894.484.562.73 1.291.744 2.19a.425.425 0 10.85-.013c-.019-1.1-.33-2.03-.978-2.783-.648-.753-1.506-1.1-2.527-1.138h-.03z"/>
    </svg>
);

const WhatsAppIcon = () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
);

export default function ShareButtons({ url, title, description, type = 'product', productId, merchantId }) {
    const [copied, setCopied] = useState(false);
    const shareUrl = url || window.location.href;
    const shareText = title || document.title;

    // OG-prerendered URL for social crawlers (Viber, FB, WhatsApp)
    const API_URL = process.env.REACT_APP_API_URL || '';
    const ogUrl = productId 
        ? `${API_URL}/og/product/${productId}`
        : merchantId 
            ? `${API_URL}/og/shop/${merchantId}` 
            : shareUrl;

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            toast.success('Link αντιγράφηκε!');
            setTimeout(() => setCopied(false), 2000);
        } catch {
            toast.error('Αποτυχία αντιγραφής');
        }
    };

    const buttons = [
        {
            name: 'Facebook',
            icon: <Facebook className="w-5 h-5" />,
            onClick: () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(ogUrl)}`, '_blank', 'width=600,height=400'),
            color: 'hover:bg-[#1877F2] hover:text-white',
        },
        {
            name: 'WhatsApp',
            icon: <WhatsAppIcon />,
            onClick: () => window.open(`https://wa.me/?text=${encodeURIComponent(`${shareText}\n${ogUrl}`)}`, '_blank'),
            color: 'hover:bg-[#25D366] hover:text-white',
        },
        {
            name: 'Viber',
            icon: <ViberIcon />,
            onClick: () => window.open(`viber://forward?text=${encodeURIComponent(`${shareText}\n${ogUrl}`)}`, '_self'),
            color: 'hover:bg-[#7360F2] hover:text-white',
        },
        {
            name: 'Instagram',
            icon: <InstagramIcon />,
            onClick: copyToClipboard,
            color: 'hover:bg-gradient-to-br hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF] hover:text-white',
            tooltip: 'Αντιγραφή link για Instagram',
        },
        {
            name: 'SMS',
            icon: <Smartphone className="w-5 h-5" />,
            onClick: () => window.open(`sms:?body=${encodeURIComponent(`${shareText}\n${ogUrl}`)}`, '_self'),
            color: 'hover:bg-green-600 hover:text-white',
        },
        {
            name: copied ? 'Copied!' : 'Copy',
            icon: copied ? <Check className="w-5 h-5" /> : <Copy className="w-5 h-5" />,
            onClick: copyToClipboard,
            color: copied ? 'bg-green-600 text-white' : 'hover:bg-foreground hover:text-background',
        },
    ];

    return (
        <div className="flex items-center gap-2 flex-wrap" data-testid="share-buttons">
            <span className="text-sm text-muted-foreground flex items-center gap-1.5">
                <Share2 className="w-4 h-4" />
                Κοινοποίηση:
            </span>
            {buttons.map((btn) => (
                <button
                    key={btn.name}
                    onClick={btn.onClick}
                    title={btn.tooltip || btn.name}
                    className={`w-9 h-9 rounded-full border flex items-center justify-center transition-all duration-200 ${btn.color}`}
                    data-testid={`share-${btn.name.toLowerCase()}-btn`}
                >
                    {btn.icon}
                </button>
            ))}
        </div>
    );
}
